import signUpTypes from './types'

const initialState = {
  actualStep: 1,
  step1: {
    url: '',
    brandName: '',
    cnpj: '',
    razaoSocial: '',
    address: '',
    number: '',
    complement: '',
    zipCode: '',
    city: '',
    state: '',
    country: 'BR'
  },
  step2: {
    id: 0,
    name: '',
    lastName: '',
    // document: '',
    cellphone: '',
    email: '',
    password: '',
    confirmPassword: ''
  },
  step3: {
    products: [],
    productSelected: null
  },
  step4: {
    paymentType: 'creditCard',
    creditCard: {
      cardNumber: '',
      cardHolderName: '',
      cardExpiringDate: '',
      cardCvv: '',
      installments: ''
    },
    coupon: ''
  },
  step5: {
    purchase: null,
    payment: null
  },
  error: ''
}

const SignUpReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case signUpTypes.RESET_STATE: {
      return { ...initialState }
    }

    case signUpTypes.SET_ACTUAL_STEP: {
      return {
        ...state,
        actualStep: payload.actualStep
      }
    }

    case signUpTypes.SET_STEP1: {
      return {
        ...state,
        step1: {
          ...state.step1,
          url: payload.url,
          brandName: payload.brandName,
          cnpj: payload.cnpj,
          razaoSocial: payload.razaoSocial,
          address: payload.address,
          number: payload.number,
          complement: payload.complement,
          zipCode: payload.zipCode,
          city: payload.city,
          state: payload.state,
          country: payload.country
        }
      }
    }

    case signUpTypes.SET_STEP2: {
      return {
        ...state,
        step2: {
          ...state.step2,
          id: payload.id ?? 0,
          name: payload.name,
          lastname: payload.lastname,
          // document: payload.document,
          cellphone: payload.cellphone,
          email: payload.email,
          password: payload.password,
          confirmPassword: payload.confirmPassword
        }
      }
    }

    case signUpTypes.SET_STEP3: {
      return {
        ...state,
        step3: {
          ...state.step3,
          products: payload.products,
          productSelected: payload.productSelected
        }
      }
    }

    case signUpTypes.SET_STEP4: {
      return {
        ...state,
        step4: {
          ...state.step4,
          paymentType: payload.paymentType,
          creditCard: {
            ...state.step4.creditCard,
            cardNumber: payload.creditCard.cardNumber,
            cardHolderName: payload.creditCard.cardHolderName,
            cardExpiringDate: payload.creditCard.cardExpiringDate,
            cardCvv: payload.creditCard.cardCvv,
            installments: payload.creditCard.installments
          },
          coupon: payload.coupon
        }
      }
    }

    case signUpTypes.SET_STEP5: {
      return {
        ...state,
        step5: {
          ...state.step5,
          purchase: payload.purchase,
          payment: payload.payment
        }
      }
    }

    case signUpTypes.SET_ERROR: {
      return {
        ...state,
        error: payload.error
      }
    }

    default:
      return state
  }
}

export default SignUpReducer
